export default __webpack_public_path__ + "static/media/yok-hat-colored.12d6521e.svg";